import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AttendanceService, { AttendanceRecord } from '../services/AttendanceService';
import './AttendanceHistoryScreen.css';

const AttendanceHistoryScreen: React.FC = () => {
  const navigate = useNavigate();
  const [attendanceRecords, setAttendanceRecords] = useState<AttendanceRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAttendanceHistory();
  }, []);

  const loadAttendanceHistory = async () => {
    try {
      const records = await AttendanceService.getAttendanceHistory();
      setAttendanceRecords(records);
    } catch (error) {
      console.error('Error loading attendance history:', error);
    } finally {
      setLoading(false);
    }
  };

  const clearHistory = async () => {
    if (window.confirm('Are you sure you want to clear all attendance records?')) {
      try {
        await AttendanceService.clearHistory();
        setAttendanceRecords([]);
      } catch (error) {
        console.error('Error clearing history:', error);
        alert('Error clearing history. Please try again.');
      }
    }
  };

  const renderAttendanceItem = (item: AttendanceRecord) => (
    <div key={item.id} className="record-item">
      <div className="record-header">
        <span className="record-date">{new Date(item.timestamp).toLocaleDateString()}</span>
        <span className="record-time">{new Date(item.timestamp).toLocaleTimeString()}</span>
        <span className="sync-status">✅</span>
      </div>

      <div className="record-details">
        {/* <div className="record-row">
          <span className={`record-type ${item.type}`}>
            {item.type === 'entry' ? '📥 Entry' : '📤 Exit'}
          </span>
        </div> */}

        <div className="record-location">
          Location: {item.location.latitude.toFixed(6)}, {item.location.longitude.toFixed(6)}
        </div>

        {item.punchCode && (
          <div className="record-punch-code">
            Punch Code: {item.punchCode}
          </div>
        )}

        {/* {item.facesDetected && (
          <div className="record-faces">
            Faces Detected: {item.facesDetected}
          </div>
        )} */}

        <div className="record-status">
          Status: {item.backendSuccess ? 'Verified' : 'Pending'}
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="history-screen">
        <div className="loading-container">
          <h2>Loading attendance history...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="history-screen">
      <div className="header">
        <h1>Attendance Records</h1>
        <div className="nav-buttons">
          <button className="nav-button" onClick={() => navigate('/')}>
            Home
          </button>
          <button className="nav-button danger" onClick={clearHistory}>
            Clear
          </button>
        </div>
      </div>

      <div className="main-content">
        {attendanceRecords.length === 0 ? (
          <div className="empty-container">
            <div className="empty-icon">📄</div>
            <h3>No attendance records found</h3>
            <p>Start marking attendance to see records here.</p>
          </div>
        ) : (
          <div className="records-list">
            {attendanceRecords.map(renderAttendanceItem)}
          </div>
        )}
      </div>
    </div>
  );
};

export default AttendanceHistoryScreen; 